import React from 'react';
import BaseNode from './BaseBlockNode';
import { renderValue } from '../../helpers/node';
import { PGEPeriodLabelMap } from '../../../constants';
import { renderPhasesParams } from '../../../constants/phases';

function RootNode(props) {
  const {
    maxLoad, nominalVoltage, pgePeriod, presentLoadPhA, presentLoadPhB, presentLoadPhC,
    presentPowerPhA, presentPowerPhB, presentPowerPhC,
  } = props;

  return (
    <BaseNode
      {...props}
      phases={null}
      staticParams={[
        { label: 'Max Load', value: renderValue(maxLoad, 'A') },
        { label: 'Nominal Voltage', value: renderValue(nominalVoltage, 'V') },
      ]}
      dynamicParams={[
        // { label: 'ToU Period', value: renderValue(PGEPeriodLabelMap[pgePeriod]) },
        ...renderPhasesParams({
          presentLoadPhA,
          presentLoadPhB,
          presentLoadPhC,
          presentPowerPhA,
          presentPowerPhB,
          presentPowerPhC,
        }),
      ]}
    />
  );
}

export default RootNode;
